import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { confirmEmail } from '../api/ConfirmEmail';
import '../styles/ConfirmEmail.css';
import NameLogo from '../assets/NameLogo.png'

function ConfirmEmail() {
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const { token } = useParams();

    useEffect(() => {
        confirmEmail(token)
            .then((data) => {
                if (data.success) {
                    setMessage('Az email sikeresen megerősítve.');
                    setSuccess(true);
                } else {
                    setMessage('Hiba történt, a link nem érvényes.');
                }
            });
    }, [token]);

    return (
        <div className='confirm-container'>
            <div className='confirm-box'>
            <img className='name-logo' src={NameLogo} alt="DookiLogo" />
                <h2 className='title1'>E-mail megerősítés</h2>
                <p className='confirm-message'>{message}</p>
                {success && <Link className='login-link' to="/login">Bejelentkezés</Link>}
            </div>
        </div>
    );
}

export default ConfirmEmail;
